<template>
  <bootstrap-collapse :visible="visible">
    <b-card-text >
      <b-card-title class="h3 mb-0">Filtrar resultados</b-card-title>
      <div class="col-lg-12" style="text-align: right;"></div>
      <small class="text-muted"
        >Defina um ou mais valores para cada filtro</small
      >
      <b-row>
        <b-col id="selectCategorie" md="6">
          <div  class=" pt-3 pb-2">Categoria de entrada financeira:</div>
          <multiselect
            :multiple="true"
            placeholder="Pesquisar..."
            deselect-label="Remover"
            select-label="Adicionar"
            selected-label="Selecionado"
            v-model="selectedInputCategories"
            :options="inputCategories"
            :searchable="true"
          ></multiselect>
        </b-col>
        <b-col id="selectOutputCategorie" md="6">
          <div class="pt-3 pb-2">Centro de custo:</div>
          <multiselect
            :multiple="true"
            placeholder="Pesquisar..."
            deselect-label="Remover"
            select-label="Adicionar"
            selected-label="Selecionado"
            v-model="selectedOutputCategories"
            :options="outputCategories"
            :searchable="true"
          ></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col id="selectedClients" md="6">
          <div class="pt-3 pb-2">Cliente:</div>
          <multiselect
            :multiple="true"
            placeholder="Pesquisar..."
            deselect-label="Remover"
            select-label="Adicionar"
            selected-label="Selecionado"
            v-model="selectedClients"
            :options="clients"
            :searchable="true"
          ></multiselect>
        </b-col>
        <b-col id="selectedAgents" md="6">
          <div class="pt-3 pb-2"></div>
          Fornecedor:
          <multiselect
            :multiple="true"
            placeholder="Pesquisar..."
            deselect-label="Remover"
            select-label="Adicionar"
            selected-label="Selecionado"
            v-model="selectedAgents"
            :options="agents"
            :searchable="true"
          ></multiselect>
        </b-col>
      </b-row>
    </b-card-text>
  </bootstrap-collapse>
</template>

<script>
import BootstrapCollapse from "@/components/BootstrapCollapse/BootstrapCollapse";
import { Select, Option, Col } from "element-ui";
import Multiselect from 'vue-multiselect'
import bocapioCakeService from "../../services/cakephp/index"
//import { axios } from 'axios';
import { mapGetters } from "vuex";
import { map } from 'd3';


var axios = require("axios");

export default {
  name: "search-filter",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    inputCategories: {
      type: Array,
      default: () => []
    },
    outputCategories: {
      type: Array,
      default: () => []
    },
    agents: {
      type: Array,
      default: () => []
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  components: {
     Multiselect,
    BootstrapCollapse,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col
  },
  watch:{
      selectedInputCategories(novo,old){
        this.$emit('categoriesSelected',Object.values(novo))
      },
      selectedOutputCategories(novo,old){
        this.$emit('outCategoriesSelected',Object.values(novo))
      },
      selectedClients(novo,old){
        this.$emit('clientsSelected',Object.values(novo))
      },
      selectedAgents(novo,old){
        this.$emit('agentsSelected',Object.values(novo))
      },
  },
  data() {
    return {
      selectedInputCategories: [],
      selectedOutputCategories: [],
      selectedClients: [],
      selectedAgents: [],
      
    };
  },
  
  computed: {
    ...mapGetters([
       "params"
    ]),
  },
  
  methods: {
    emitFiltersValues() {
      console.log("Emit");
    },
    
    
      
  }
  
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

